<template>
    <div>
        <div>
            <div class="form-check-label" :style="'border: 2px solid #e4e6e7; padding: 10px; border-radius: 24px'">
                <div class="d-flex align-items-center space-between">
                    <div class="ms-2 w-100">
                        <span class="fw-bold">Klarna en 3 fois</span>
                    </div>
                </div>

                <span style="margin-left: 10px; color: red" v-if="errorPrelever">{{ errorPrelever }}</span>
                <div v-if="currentOrder?.total_price-currentOrder?.current_price<35"  style="margin-top: 20px" class="d-flex justify-center clientCards">
                    <span style="margin: auto; margin-left: 6px">{{ parseFloat((currentOrder?.total_price-currentOrder?.current_price)/3).toFixed(2) }} €</span>

                    <v-btn
                        type="button"
                        style="margin-right: 10px; color: white; font-family: Roboto;border-radius: 24px"
                        @click="preleverKlarna"
                       :disabled="true"

                        :loading="loadingPreleve"
                        color="#2F4858"
                    >
                       0
                    </v-btn>
                </div>
                <div v-else  style="margin-top: 20px" class="d-flex justify-center clientCards">
                    <span style="margin: auto; margin-left: 6px">{{ parseFloat((currentOrder?.total_price-currentOrder?.current_price)/3).toFixed(2) }} €</span>

                    <v-btn
                        type="button"
                        style="margin-right: 10px; color: white; font-family: Roboto;border-radius: 24px"
                        @click="preleverKlarna"
                       :disabled="false"

                        :loading="loadingPreleve"
                        color="#2F4858"
                    >
                        Payer sur 3 fois avec klarna
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.clientCards .v-input__slot {
    border-radius: 24px;
}
</style>
<script>
import axios from 'axios'
export default {
    props: ['userId', 'orderId','currentOrder'],
    data: () => {
        return {
            menu: false,
            cartNum: null,
            expire: null,
            cvv: null,
            loadingAddCart: false,
            clientCards: [],
            selectCard: null,
            loadingPreleve: false,
            errorPrelever: null,
            amount: 0
        }
    },
    methods: {
        async preleverKlarna() {
            this.errorPrelever = null
            this.loadingPreleve = true
            axios
                .post(
                    `/back-office/caisse/payByklarna`,
                    {

                        userId: this.userId,
                        orderId: this.orderId,
                        amount: this.currentOrder.total_price - this.currentOrder.current_price
                    },
                    { withCredentials: true }
                )
                .then((res) => {
                    window.location.href=res.data.url
                })
                .catch(error => {
                    this.errorPrelever = error?.response?.data?.message || 'Une erreur est survenue'
                })
                .finally(() => {
                    this.loadingPreleve = false
                })
        },
    },
}
</script>
